import type { ReactNode } from 'react';

import { Toaster } from '@/components/ui/sonner';

interface ToastProviderProps {
  children: ReactNode;
}

/**
 * Toast provider.
 *
 * @param {ToastProviderProps} props - Component props.
 * @param {string | number | bigint | boolean | ReactElement<unknown, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | Promise<AwaitedReactNode> | null | undefined} props.children - The children.
 *
 * @returns {JSX.Element} The rendered element.
 */
export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <Toaster position="bottom-center" />
    </>
  );
}
